// material ui
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

// Tabler icon "sun" - used for the morning greeting.
export default function SunIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{ fill: 'none', stroke: 'currentColor', ...props.sx }}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
      />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
      />
    </SvgIcon>
  );
}
